<template>
    <div class="team-page">
        <!--  职能简介   -->
        <div>
            <div class="title-wrap">
                <img
                    :src="
                        require('@/assets/images/project-detail/team-job.png')
                    "
                    alt=""
                    class="icon"
                />
                <span>职能简介</span>
            </div>
            <!--       人员图片     -->
            <div class="job-img-content">
                <img
                    class="image"
                    v-lazy="
                        require('@/assets/images/project-detail/concise_img.png')
                    "
                    alt=""
                />
            </div>
        </div>
        <!--  服务队名单   -->
        <div>
            <div class="title-wrap">
                <img
                    :src="
                        require('@/assets/images/project-detail/team-server.png')
                    "
                    alt=""
                    class="icon"
                />
                <span>服务队名单</span>
            </div>
            <!--      人员列表      -->
            <div class="person-list-wrap">
                <div
                    class="person-item"
                    v-for="item in projectDetail.servicer"
                    :key="item.id"
                >
                    <!--           人员基本信息         -->
                    <div
                        class="person-basic-info"
                        :class="{
                            'person-basic-info-small': item.aptitudeList,
                        }"
                    >
                        <div class="person-basic-content">
                            <img
                                class="head-image"
                                :src="item.icon"
                                alt=""
                            />
                            <div class="person-service">
                                <div class="name-info">
                                    <span class="name">{{ item.name }}</span>
                                    <span class="no">{{ item.job_number }}</span>
                                </div>
<!--                                <div class="start-wrap">-->
<!--                                    <img-->
<!--                                        class="start-icon"-->
<!--                                        v-for="ite in item.score_rang"-->
<!--                                        :key="ite"-->
<!--                                        :src="-->
<!--                                            require('@/assets/images/project-detail/team-satrt-full.png')-->
<!--                                        "-->
<!--                                        alt=""-->
<!--                                    />-->
<!--                                    <img-->
<!--                                        class="start-icon"-->
<!--                                        v-for="ite in (5 - item.score_rang)"-->
<!--                                        :key="ite + 5"-->
<!--                                        :src="-->
<!--                                            require('@/assets/images/project-detail/team-satrt-empty.png')-->
<!--                                        "-->
<!--                                        alt=""-->
<!--                                    />-->
<!--                                    <span-->
<!--                                        >{{ item.score_rang + "分" }}-->
<!--                                    </span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="job-tag">{{ item.group_name }}</div>
                    </div>

                    <!--            人员资质信息        -->
                    <div v-if="item.new_aptitude" class="person-aptitude">
                        <div
                            class="aptitude-item"
                            v-for="apt in item.new_aptitude"
                            :key="apt.name"
                        >
                            <img class="icon" :src="apt.icon" alt="" />
                            <p class="text">{{ apt.name }}</p>
                        </div>
                    </div>
                    <div v-if="item.group_name == '施工队长'&& item.new_aptitude.length == 0" class="person-aptitude">
                        <div class="aptitude-item">
                            <img class="icon" src="@/assets/images/project-detail/default-icon.png" alt="" />
                            <p class="text">系统家电施工资质</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { projectDetailMixin } from "@/page/project/detail/mixin";
import {mapState} from "vuex";
export default {
  name: "team",
  mixins: [projectDetailMixin],
  computed: {
       ...mapState({
            // 项目详情
            projectDetail: (state) => state.proposalModule.projectDetail
        }),
  },
 data () {
     return {
          // 团队人员
        arrTeamPerson: [
            {
                name: '李*楠', // 姓名
                no: 'OS621812', // 编号
                job: '项目经理', // 职位
                headImage:require('@/assets/images/project-detail/team-manager-icon.png'),
                evaValue: 5, // 评分
            },
            {
                name: '赵*坤', // 姓名
                no: 'OS621765', // 编号
                headImage:require('@/assets/images/project-detail/team-manager-icon.png'),
                job: '监理', // 职位
                evaValue: 4, // 评分
            },
            {
                name: '吴*鹏', // 姓名
                no: 'OS620913', // 编号
                job: '施工队长', // 职位
                headImage:require('@/assets/images/project-detail/team-worker-icon.png'),
                evaValue: 5, // 评分
                aptitudeList: [
                    {
                        name: '电工资质',
                        icon:require('@/assets/images/project-detail/team-electrician-icon.png')
                    },
                    {
                        name: '燃气产品施工资质',
                        icon:require('@/assets/images/project-detail/team-gas-icon.png')
                    },
                    {
                        name: '高空作业资质',
                        icon:require('@/assets/images/project-detail/team-work1-icon.png')
                    },
                    {
                        name: '制冷产品施工资质',
                        icon:require('@/assets/images/project-detail/team-work3-icon.png')
                    },
                    {
                        name: '焊工资质',
                        icon:require('@/assets/images/project-detail/team-work2-icon.png')
                    },
                ]
            },
            {
                name: '刘*', // 姓名
                no: 'OS601357', // 编号
                headImage:require('@/assets/images/project-detail/team-worker-icon.png'),
                job: '施工员', // 职位
                evaValue: 4, // 评分
                aptitudeList: [
                    {
                        name: '电工资质',
                        icon:require('@/assets/images/project-detail/team-electrician-icon.png')
                    },
                    {
                        name: '燃气产品施工资质',
                        icon:require('@/assets/images/project-detail/team-gas-icon.png')
                    },
                    {
                        name: '高空作业资质',
                        icon:require('@/assets/images/project-detail/team-work1-icon.png')
                    },
                    {
                        name: '制冷产品施工资质',
                        icon:require('@/assets/images/project-detail/team-work3-icon.png')
                    },
                ]
            },
            {
                name: '王*洋', // 姓名
                no: 'OS676323', // 编号
                headImage:require('@/assets/images/project-detail/team-worker-icon.png'),
                job: '施工员', // 职位
                evaValue: 5, // 评分
                aptitudeList: [
                    {
                        name: '电工资质',
                        icon:require('@/assets/images/project-detail/team-electrician-icon.png')
                    },
                    {
                        name: '高空作业资质',
                        icon:require('@/assets/images/project-detail/team-work1-icon.png')
                    },
                    {
                        name: '制冷产品施工资质',
                        icon:require('@/assets/images/project-detail/custome/job-zhineng.png')
                    }
                ]
            }
        ]
     }
 },
  created() {
    //   this.$teamstore.dispatch('getProjectTeam', { projectmgnid: this.projectDetail.id });
    //   console.log('7777', this.projectDetail.servicer);
  },

  methods: {
    //   this.$userHouse.dispatch("getProjectTeam", { })
    //   console.log(this.$store.)
  }
};
</script>

<style scoped lang="scss">
.team-page {
    padding: 30px 24px 180px;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }

    .title-wrap {
        display: flex;
        align-items: center;
        font-size: $bigSize;
        color: $defaultGreen;
        font-weight: 600;
        margin-bottom: 24px;

        .icon {
            width: 40px;
            height: 40px;
            margin-right: 8px;
        }
    }

    .job-img-content {
        margin-bottom: 40px;
        border-radius: 10px;
        overflow: hidden;

        .image {
            width: 100%;
            height: auto;
        }
    }

    .person-list-wrap {
        color: #ffffff;

        .person-item {
            border-radius: 10px;
            overflow: hidden;
            box-shadow: $boxShadow;
            margin-bottom: 28px;
            font-size: $baseSize;

            .person-basic-info {
                height: 172px;
                padding: 0 28px;
                background: $greenGradient;
                display: flex;
                align-items: center;
                position: relative;

                .person-basic-content {
                    display: flex;
                    align-items: center;

                    .head-image {
                        flex: 0 0 auto;
                        width: 88px;
                        height: 88px;
                        margin-right: 20px;
                        border-radius: 100%;
                    }

                    .person-service {
                        flex: 1;

                        .name-info {
                            display: flex;
                            align-items: center;

                            .name {
                                opacity: 1;
                                font-weight: 600;
                                font-size: $bigSize;
                                line-height: 52px;
                                padding-right: 38px;
                            }

                            .no {
                                opacity: 0.8;
                                font-size: $smallSize;
                                line-height: 40px;
                            }
                        }

                        .start-wrap {
                            margin-top: 6px;
                            display: flex;
                            align-items: center;

                            .start-icon {
                                width: 28px;
                                height: 28px;
                                margin-right: 20px;
                            }

                            span {
                                line-height: 32px;
                                font-size: $smallSize;
                                color: #ffcb03;
                                padding: 0 4px;
                            }
                        }
                    }
                }

                .job-tag {
                    position: absolute;
                    right: 0;
                    top: 0;
                    // width: 148px;
                    // height: 48px;
                    // line-height: 48px;
                    text-align: center;
                    padding: 5px 10px;
                    border-bottom-left-radius: 10px;
                    color: $defaultGreen;
                    background: #ffffff;
                }
            }

            .person-basic-info-small {
                height: 132px;
            }

            .person-aptitude {
                padding: 24px 26px 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                font-size: $bigSize;
                color: $defaultBlack;

                .aptitude-item {
                    flex: 42%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 32px;

                    &:nth-child(even) {
                        flex: 50%;
                    }

                    .icon {
                        width: 68px;
                        height: 68px;
                        margin-right: 20px;
                    }

                    .text {
                        line-height: 44px;
                    }
                }
            }
        }
    }
}
</style>
